module.exports = __webpack_public_path__ + "images/organization/green-face.0f4410938f763fec6402.svg";